export default "__VITE_ASSET__CkJtw07c__"